import baseBranchStore from "../stores/baseBranchStore.js";
import languageStore from "../stores/languageStore.js";
import userStore from "../stores/userStore.js";
import ServiceBase from "./ServiceBase.js";
class AuthenticatedServiceBase extends ServiceBase {
  authorizedDelete(args) {
    return this.requestWithTimeout({
      getTimeZone: args.getTimeZone ?? this.getTimeZone,
      onAbort: args.onAbort,
      request: (signal) => fetch(this.getFullUrl(args), {
        body: this.getBody(args),
        credentials: "include",
        headers: this.getHeaders(args),
        method: "DELETE",
        signal
      }),
      timeoutSeconds: args.timeoutSeconds
    });
  }
  authorizedGet(args) {
    return this.requestWithTimeout({
      getTimeZone: (args == null ? void 0 : args.getTimeZone) ?? this.getTimeZone,
      isRetrySafe: true,
      onAbort: args == null ? void 0 : args.onAbort,
      request: (signal) => fetch(this.getFullUrl(args), {
        credentials: "include",
        headers: this.getHeaders(args),
        signal
      }),
      timeoutSeconds: args == null ? void 0 : args.timeoutSeconds
    });
  }
  authorizedPatch(args) {
    return this.requestWithTimeout({
      getTimeZone: args.getTimeZone ?? this.getTimeZone,
      onAbort: args.onAbort,
      request: (signal) => fetch(this.getFullUrl(args), {
        body: this.getBody(args),
        credentials: "include",
        headers: this.getHeaders(args),
        method: "PATCH",
        signal
      }),
      timeoutSeconds: args.timeoutSeconds
    });
  }
  authorizedPost(args) {
    return this.requestWithTimeout({
      getTimeZone: args.getTimeZone ?? this.getTimeZone,
      isRetrySafe: args.isRetrySafe,
      onAbort: args.onAbort,
      request: (signal) => fetch(this.getFullUrl(args), {
        body: this.getBody(args),
        credentials: "include",
        headers: this.getHeaders(args),
        method: "POST",
        signal
      }),
      timeoutSeconds: args.timeoutSeconds
    });
  }
  authorizedPut(args) {
    return this.requestWithTimeout({
      getTimeZone: args.getTimeZone ?? this.getTimeZone,
      isRetrySafe: args.isRetrySafe,
      onAbort: args.onAbort,
      request: (signal) => fetch(this.getFullUrl(args), {
        body: this.getBody(args),
        credentials: "include",
        headers: this.getHeaders(args),
        method: "PUT",
        signal
      }),
      timeoutSeconds: args.timeoutSeconds
    });
  }
  getBody(args) {
    const getTimeZone = args.getTimeZone ?? this.getTimeZone;
    if (args.formParams) {
      return this.buildFormData(args.formParams, getTimeZone);
    }
    if (args.postData) {
      return JSON.stringify(
        this.buildJsonData(args.postData, getTimeZone, void 0, "")
      );
    }
    return void 0;
  }
  getFullUrl(args) {
    return this.buildUrl(
      args == null ? void 0 : args.url,
      args == null ? void 0 : args.pathParams,
      args == null ? void 0 : args.queryParams,
      (args == null ? void 0 : args.getTimeZone) ?? this.getTimeZone
    );
  }
  getHeaders(args) {
    const headers = new Headers({
      "Accept-Language": languageStore.get().localeId
    });
    if (!args || !("formParams" in args) || !args.formParams) {
      headers.append("Content-Type", "application/json; charset=utf-8");
    }
    if (userStore.isSignedIn()) {
      headers.append("Authorization", `Bearer ${userStore.get().accessToken}`);
    }
    return headers;
  }
  getTimeZone() {
    return baseBranchStore.getTimezone();
  }
}
export {
  AuthenticatedServiceBase as default
};
//# sourceMappingURL=AuthenticatedServiceBase.js.map
